import React, { Component } from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";

//Stepper
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

//List
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import LinearProgress from "@material-ui/core/LinearProgress";

//Components
import ControlPanel from "./ControlPanel";

//Util
import compare from "./../../../util/compare";

const getSteps = () => [
  "buildings",
  // "devices",
  "controls"
];

const getStepContent = stepIndex => {
  switch (stepIndex) {
    case 0:
      return "select a building from the list";
    case 1:
      return "select a device from the list";
    // case 2:
    //   return "live control data";
    default:
      return "Uknown stepIndex";
  }
};

const generateList = (data, activeStep, selectedBuilding, selectedDevice, handleClick) => {
  if (!data) {
    return <LinearProgress />;
  }

  switch (activeStep) {
    case 0: {
      const buildings = Object.keys(data).map((a, i) => {
        return (
          <ListItem button onClick={event => handleClick(event, a, "building")} key={a}>
            <ListItemText
              primary={String(a).toUpperCase()}
              style={{ maxWidth: "100%", textAlign: "center" }}
            />
          </ListItem>
        );
      });
      return buildings.sort(compare);
    }

    case 1: {
      const devices = Object.keys(data[selectedBuilding]).map((a, i) => {
        return (
          <ControlPanel
            key={`${a}`}
            name={a}
            buildingName={selectedBuilding}
            data={data[selectedBuilding][a]}
          />
        );
      });
      return devices.sort(compare);
    }

    // case 1: {
    //   const devices = Object.keys(data[selectedBuilding]).map((a, i) => {
    //     return (
    //       <ListItem button onClick={event => handleClick(event, a, "device")} key={a}>
    //         <ListItemText
    //           primary={String(a).toUpperCase()}
    //           style={{ maxWidth: "100%", textAlign: "center" }}
    //         />
    //       </ListItem>
    //     );
    //   });
    //   return devices.sort(compare);
    // }

    // case 2: {
    //   const controls = Object.keys(data[selectedBuilding][selectedDevice]).map((a, i) => {
    //     return (
    //       <ControlPanel
    //         key={`${a}`}
    //         name={a}
    //         buildingName={selectedBuilding}
    //         data={data[selectedBuilding][selectedDevice][a]}
    //       />
    //     );
    //   });
    //   return controls.sort(compare);
    // }

    default: {
      return null;
    }
  }
};

class dataStepper extends Component {
  state = {
    activeStep: 0,
    selectedBuilding: 0,
    selectedDevice: 0,
    selectedUnit: 0
  };

  //Handlers
  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  handleListItemClick = (event, choice, type) => {
    // eslint-disable-next-line
    type === "building"
      ? this.setState({ selectedBuilding: choice })
      : type === "device"
      ? this.setState({ selectedDevice: choice })
      : type === "unit"
      ? this.setState({ selectedUnit: choice })
      : null;
    this.handleNext();
  };

  render() {
    const { classes, data } = this.props;
    const { activeStep, selectedBuilding, selectedDevice } = this.state;
    const steps = getSteps();

    return (
      // Header
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>

        {/* Step */}
        <div className={classes.root}>
          <List component="nav" className={classes.list}>
            {generateList(
              data,
              activeStep,
              selectedBuilding,
              selectedDevice,
              this.handleListItemClick
            )}
          </List>
        </div>

        {/* Footer */}
        <div>
          {this.state.activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>all steps completed</Typography>
              <Button onClick={this.handleReset}>Reset</Button>
            </div>
          ) : (
            <div>
              <div className={classes.buttons}>
                <Button
                  disabled={activeStep === 0}
                  onClick={this.handleBack}
                  className={classes.backButton}>
                  Back
                </Button>
                {activeStep === steps.length - 1 ? (
                  <Button variant="contained" color="primary" onClick={this.handleReset}>
                    Finish
                  </Button>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

//Styles
const styles = theme => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  list: {
    display: "flex",
    flexDirection: "column"
  },
  backButton: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    textAlign: "center",
    padding: "1em"
  },
  buttons: {
    float: "right"
  }
});

dataStepper.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(dataStepper);



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/Setpoints/PointStepper.js